import routes from '@/modules/metadata-mapping/metadata-mapping-routes';
import store from '@/modules/metadata-mapping/metadata-mapping-store';
export default {
    component: [],
    routes,
    store,
}
